/* eslint-disable no-param-reassign */
import { createSlice } from "@reduxjs/toolkit";

const cartSlice = createSlice({
  name: "cartSlice",
  initialState: {
    cart: [],
  },
  reducers: {
    addCart: (state, action) => {
      const { id, name, price, photo, type, park, quantity,description,offerPrice } = action.payload;
      const exists = state.cart.find(
        (item) => item.id === id && item.type === type
      );
      if (exists) {
        exists.quantity = quantity;
        exists.totalPrice = quantity * (offerPrice || price);
      } else {
        const newData = {
          id,
          name,
          price,
          offerPrice,
          totalPrice: quantity*(offerPrice || price),
          photo,
          type,
          quantity,
          park,
          description
        };
        state.cart.push(newData);
      }
      localStorage.setItem("cart", JSON.stringify(state.cart));
    },
    removeCart: (state, action) => {
      const { id, type } = action.payload;
      const updatedCart = state.cart.filter(
        (cartItem) => !(cartItem.id === id && cartItem.type === type)
      );
      state.cart = updatedCart;
      localStorage.setItem("cart", JSON.stringify(state.cart));
    },
    increment: (state, action) => {
      if (action.payload) {
        const { id, type, park } = action.payload;
        const parkExists = state.cart.find(
          (cartItem) => cartItem.park === park
        );
        if (parkExists) {
          const exists = state.cart.find(
            (item) => item.id === id && item.type === type
          );
          exists.quantity += 1;
          exists.totalPrice = exists.quantity *(exists.offerPrice || exists.price);
          localStorage.setItem("cart", JSON.stringify(state.cart));
        }
      }
    },
    decrement: (state, action) => {
      if (action.payload) {
        const { id, type, park } = action.payload;
        const parkExists = state.cart.find(
          (cartItem) => cartItem.park === park
        );
        if (parkExists) {
          const exists = state.cart.find(
            (item) => item.id === id && item.type === type
          );
          if (exists.quantity > 1) {
            exists.quantity -= 1;
            exists.totalPrice = exists.quantity * (exists.offerPrice || exists.price);
          }
          localStorage.setItem("cart", JSON.stringify(state.cart));
        }
      }
    },
    getCart: (state) => {
      const storage = localStorage.getItem("cart");
      if (storage) {
        state.cart = JSON.parse(storage);
      }
    },
    clearCart: (state) => {
      localStorage.removeItem("cart");
      state.cart = [];
    },
  },
});
export const { addCart, increment, decrement, removeCart, getCart, clearCart } =
  cartSlice.actions;

export default cartSlice.reducer;
